import React from 'react';
import { ArrowRight } from 'lucide-react';

interface CivicButtonProps {
  children: React.ReactNode;
  href: string;
  target?: string;
  rel?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'ghost';
  startIcon?: React.ReactNode;
}

const CivicButton: React.FC<CivicButtonProps> = ({
  children,
  href,
  target,
  rel,
  size = 'medium',
  variant = 'primary',
  startIcon,
}) => {
  return (
    <a
      href={href}
      target={target}
      rel={rel}
      className={`civic-btn civic-btn--${variant} civic-btn--${size}`}
    >
      {startIcon}
      <span>{children}</span>
      <ArrowRight size={16} aria-hidden="true" />
    </a>
  );
};

export default CivicButton;
